export class MemberTpiccvData {
    public id: string = "0";
    public member_id: string;
    public member_name: string;
    public date: Date;
    public text: string;   

    constructor() {}
}